// If this is used in more places factor to seperate component
import React from 'react';
import Icon from '@xo-union/tk-component-icons';
import styles from './AddPageButton.scss';
import cx from 'classnames';

interface Props {
  onClick: () => void;
  children?: string;
  block?: boolean;
  transparent?: boolean;
  noMargin?: boolean;
}

const AddPageButton: React.FC<Props> = ({
  onClick,
  block = false,
  transparent = false,
  noMargin = false,
  children = 'Add a Custom Page',
}) => {
  const buttonStyle = cx(
    styles.addPageButton,
    { [styles.addPageButton__fullWidth]: block },
    { [styles.addPageButton__transparent]: transparent },
    { [styles.addPageButton__noMargin]: noMargin }
  );
  return (
    <button className={buttonStyle} data-testid="add-page" onClick={onClick}>
      <Icon name="add_circle" size="md" className={styles.addPageButton__addIcon} /> {children}
    </button>
  );
};

export default AddPageButton;
